<div class="outer-container">

  @if (dateUtcWithTimeZone) {
    @if (rawDateWithNoTime) {
      <div>{{ dateUtcWithTimeZone | date: 'MM/dd/yyyy' : "UTC" }}</div>
    } @else {
      @if (singleLine) {
        <div class="single-line">
          <span>{{ dateUtcWithTimeZone | date: 'MM/dd/yyyy&nbsp;' : LocalTimePoint.formatZ() }}</span>
          <span>{{ dateUtcWithTimeZone | date: 'h:mm:ss&nbsp;a' : LocalTimePoint.formatZ() }}</span>
        </div>
      } @else {
        <div>
          <div>{{ dateUtcWithTimeZone | date: 'MM/dd/yyyy&nbsp;' : LocalTimePoint.formatZ() }}</div>
          <div class="dim-time">{{ dateUtcWithTimeZone | date: 'h:mm:ss&nbsp;a' : LocalTimePoint.formatZ() }}</div>
        </div>
      }
    }
  } @else {
    {{ "—" }}
  }


</div>
